import { render, staticRenderFns } from "./account-editor.vue?vue&type=template&id=55294f40&scoped=true&"
import script from "./account-editor.vue?vue&type=script&lang=ts&"
export * from "./account-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55294f40",
  null
  
)

export default component.exports